"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
var Category;
(function (Category) {
    Category["BILLING_PAYMENTS"] = "billing_payments";
    Category["OFFER_RENEW"] = "offer_renew";
    Category["TRANSFER"] = "transfer";
    Category["TERMINATION"] = "termination";
    Category["PERSONAL_DETAILS"] = "personal_details";
    Category["CONSUMPTION_SAVINGS"] = "consumption_savings";
    Category["MIJN_ESSENT"] = "my_essent / my_energiedirect";
    Category["CALAMITY"] = "calamity";
    Category["ONLINE_APPS_AND_TOOLS"] = "online_apps_and_tools";
    Category["CORRESPONDENCE"] = "Correspondence";
    Category["CUSTOMER_SCREENING"] = "customer_screening";
    Category["LOYALTY"] = "loyalty";
    Category["CONVERSATIONAL_ROUTING"] = "conversational_routing";
    Category["PAYMENT_ARRANGEMENTS"] = "payment_arrangements";
    Category["END_OF_SUPPLY"] = "endofsupply";
    Category["UNKNOWN"] = "unknown";
})(Category = exports.Category || (exports.Category = {}));
